module.exports = __webpack_public_path__ + "static/media/neural-network.8359cc17.png";